import axios from 'axios';

const get = async url => {
  return await axios.get(url, { withCredentials: true });
};

export { get };



// WEBPACK FOOTER //
// ./src/util/request.js